
import { Observable } from 'rxjs';

import { filter, map } from 'rxjs/operators';
import { ProjectsService } from "./../services/projects/projects.service";
import { UserServiceService } from "./../services/user-service/user-service.service";
import { environment } from "./../../environments/environment";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit } from "@angular/core";
import { PaymentService } from "../services/payment/payment.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  NgForm,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { AccountsService } from '../services/settings-service/accounts/accounts.service';
import { addDays, addMonths, format, isValid, parseISO, startOfDay } from "date-fns";
import swal from 'sweetalert2';
import { of } from 'rxjs/observable/of';

interface DownPaymentEntry {
  down_payment_type: string | null;
  down_payment: number | null;
  down_payment_interval: string | null;
}

@Component({
  selector: "projects",
  templateUrl: "./payment-generator.component.html",
  styleUrls: [
    "../../assets/css/style.css",
    "../../assets/css/custom.css",
    "./payment-generator.component.css",
  ],
  providers: [PaymentService]
})
export class PaymentGeneratorComponent implements OnInit {
  // generator_type => Fixed Plan, Mortage Calculator, PV Calculator
  // Fixed plan => current inputs
  // mortage calculator => current inputs + mortage calculator
  // interval select monthly 1 - quarterly 3 - semi annunal - 6 yearly - 12
  // installments_count text
  // in starting date label should be contract starting date
  // first_installment_date
  // show another table in case of mortage calculator after update

  general_settings_controles: any =
    JSON.parse(
      window.localStorage.getItem("general_settings_controles") || "{}"
    ) || {};
  methods: any = [];
  installments: any;
  arr: any;
  current_units_arr: any;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  // used for fixing select bug onchange
  separated: any;

  unit_details: any;
  unit_id: any;

  phases: any;

  new_paymentForm: any = {
    unit_id: null,
    generator_type: "Fixed Plan",
    percentage: null,
    slots: 0,
    service_room_slots: null,
    service_room_with_bathroom_slots: null,
    type: null,
    unit_serial: null,
    generated_view: "Total",
    status: null,
    build_area: null,
    maintenance_fees_date: null,
    garage_fees_date: null,
    contract_period_in_months: null,
    starting_date: new Date().toISOString().split("T")[0],
    finishing_type_id: null,
    phase_id: null,
    price: null,
    has_club_house: false,
    cash_price: null,
    extra_discount: null,
    down_payment_type: "percentage",
    interval: "3",
    down_payment_interval: "1",
    first_installment_date: null,
    installments_count: null,
    down_payment_count: null,
  };
  special_payment = {
    special_payment_type: "percentage",
    special_payment_value: null,
    special_payment_count: null,
    special_payment_interval: "12",
    special_payment_date: null,
  };
  special_payments: any = [];
  canReserveUnit: boolean = false;
  panelOpenState: boolean;
  allowedRoles: string[] = [];
  isRoleAllowed: boolean;
  generating_pdf: boolean;
  firstInstallmentDayIncrement: number = 0;
  down_payments_array: DownPaymentEntry[] = [];
  private defaultDownPayment: DownPaymentEntry = {
    down_payment_type: null,
    down_payment: null,
    down_payment_interval: null,
  };
  private defaultDownPaymentInterval = "0";
  installment_mortage;
  mortage_raw;
  special_payment_arr = [];
  down_payment_arr = [];
  maintenance_arr = [];
  regular_payment_arr = [];
  maintenance_fees_arr = [];
  garage_fees_arr = [];
  installmentsDetails = {
    down_payment_installment_count: null,
    down_payment_installment_value: null,
    down_payment_installment_total_value: null,
    first_down_payment_installment_date: null,
    down_payment_installment_periodly_value: null,
    down_payment_installment_periodly_total_value: null,


    special_payments_arr: [],
    special_payment_installment_count: null,
    special_payment_installment_value: null,
    special_payment_installment_total_value: null,
    first_special_payment_installment_date: null,
    special_payment_periodly_amount: null,
    special_payment_periodly_total_value: null,


    maintenance_installment_count: null,
    maintenance_installment_value: null,
    maintenance_installment_total_value: null,
    first_maintenance_installment_date: null,
    maintenance_fees_count: null,
    maintenance_fees_value: null,
    maintenance_fees_total_value: null,
    first_maintenance_fees_date: null,
    maintenance_fees_periodly_value: null,
    maintenance_fees_periodly_total_value: null,


    garage_fees_count: null,
    garage_fees_value: null,
    garage_fees_total_value: null,
    first_garage_fees_date: null,
    garage_fees_periodly_value: null,
    garage_fees_periodly_total_value: null,


    regular_installment_count: null,
    regular_installment_value: null,
    regular_installment_total_value: null,
    first_regular_installment_date: null,
    regular_periodly_amount: null,
    regular_periodly_total_value: null,
  };
  showMoreDetails: boolean = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private paymentService: PaymentService,
    private accountService: AccountsService,
    private userService: UserServiceService,
    private projectService: ProjectsService,
    public errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService,
  ) {
    if(this.general_settings_controles.mortgage_calculator == 'on') {
      this.new_paymentForm.generator_type = 'Mortage Calculator';
      this.onGeneratorTypeChange('Mortage Calculator');
    };
    this.setSpecialPaymentDate(this.special_payment.special_payment_interval);
  }

  ngOnInit() {
    this.checkUnitIdQueryParameter();
    this.getAllowedRoles();
  }

  getAllowedRoles() {
    this.accountService.getMortageControlsRoles().subscribe(
      (data: any) => {
        this.allowedRoles = data.allowedRoles;
        let role = this.userProfile.role;
        this.isRoleAllowed = this.allowedRoles.includes(role);
        this.route.queryParams.subscribe((qparams) => {
          if (qparams.generic_type == "PV") {
            this.new_paymentForm.generator_type = 'PV Calculator';
          }
        })
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  onExtraDiscountChange(value: any) {
    if (value > 100) {
      this.new_paymentForm.extra_discount = 100;
    } else if (value < 0) {
      this.new_paymentForm.extra_discount = 0;
    }
  }

  onFinishTypePriceChange(id) {
    this.unit_details.finishing_types.forEach((type) => {
      if (type.id == id) {
        this.new_paymentForm.price = type.pivot.price;
        this.new_paymentForm.cash_price = type.pivot.cash_price;
      }
    });
    this.methods = [];
    this.new_paymentForm.type = null;
    let params: any = this.getPaymentTermsPaylod();
    if (params.project_id && params.finishing_type_id) {
      this.installments = null;
      this.separated = null;
      this.getPaymentTerms(params);
    }
  }

  changePaymentMethod(event) {
    if (this.new_paymentForm.type != "Down Town Port Said 20 perc DP") {
      this.new_paymentForm.down_payment = "total";
    }
    this.methods.forEach((element) => {
      if (element.id == event) {
        this.new_paymentForm.percentage = element.downpayment_percentage;
      }
    });
  }

  observableSource = (keyword: any): any => {
    const data = {
      unit_serial: keyword,
    };
    if (keyword) {
      this.slimLoadingBarService.start(() => {
      });
      return this.http
        .post(
          `${environment.api_base_url}units/search/available_by_serial`,
          JSON.stringify(data)
        ).pipe(
          map((res: any) => {
            this.current_units_arr = res;
            this.slimLoadingBarService.complete();
            if (res.length == 0) {
              return of([]);
            } else {
              this.arr = [];
              res.forEach((e) => {
                this.arr.push(e.serial + " (" + e.project.name + ")");
              });
              return this.arr;
            }
          }));
    } else {
      return of([]);
    }
  };

  getPaymentTerms(params) {
    params.unit_id = this.new_paymentForm.unit_id;
    this.userService.getProjectPaymentTerms(params).subscribe(
      (res) => {
        const arr= Array.isArray(res) ? res : [];
        this.methods = arr.map((method) => ({
          ...method,
          disabled: method ? method.is_active === 0 : false,
        }));
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  valueChanged(ev) {
    if (!this.current_units_arr) return;
    this.current_units_arr.forEach((element) => {
      if (element.serial + " (" + element.project.name + ")" == ev) {
        this.new_paymentForm.unit_serial = element.serial;
        this.new_paymentForm.unit_id = element.id;
        this.unit_id = element.id;
        this.unit_details = element;
        this.new_paymentForm.project_type = element.project.type;
        this.phases = element.project.phases;
        this.new_paymentForm.status = element.status;
        this.new_paymentForm.extra_discount = element.extra_discount;
        this.new_paymentForm.type = "";
        this.new_paymentForm.phase_id = element.phase_id;
        this.new_paymentForm.build_area = element.build_area;
        this.new_paymentForm.maintenance_fees_date = null;
        this.new_paymentForm.garage_fees_date = null;
        this.new_paymentForm.contract_period_in_months = element.contract_period_in_months;
        // this.getPaymentTerms(element.project.id);
        this.new_paymentForm.percentage = "";
      }
    });
    this.unit_details.finishing_types.map((type) => {
      if (type.name == "Core and Shell") {
        this.new_paymentForm.finishing_type_id = type.id;
        this.onFinishTypePriceChange(type.id);
      }
    })
  }

  onPhaseChange(id) {
    this.methods = [];
    this.new_paymentForm.type = "";
    let payload: any = this.getPaymentTermsPaylod();
    if (payload.project_id && payload.finishing_type_id) {
      this.getPaymentTerms(payload);
    }
  }

  getPaymentTermsPaylod() {
    let payload = {
      project_id: this.unit_details.project.id,
      phase_id: this.new_paymentForm.phase_id,
      finishing_type_id: this.new_paymentForm.finishing_type_id,
      unit_id: this.unit_id,
    };
    return payload;
  }

  pdf() {
    let url = `${environment.api_raw_base_url}installments/pdf/${this.unit_details.id}/${this.new_paymentForm.type}?generated_view=${this.new_paymentForm.generated_view}&slots=${this.new_paymentForm.slots}&service_room_slots=${this.new_paymentForm.service_room_slots}&service_room_with_bathroom_slots=${this.new_paymentForm.service_room_with_bathroom_slots}&finishing_type_id=${this.new_paymentForm.finishing_type_id}&extra_discount=${this.new_paymentForm.extra_discount}`;

    if (this.userProfile.role === "Admin" || this.userProfile.role == "CFO") {
      url += `&tot_amount_for_unit=${this.new_paymentForm.price}`;
    }
    url += `&starting_date=${this.new_paymentForm.starting_date}`;
    this.new_paymentForm.generator_type == 'Mortage Calculator' ? url += `&contract_period_in_months=${this.new_paymentForm.contract_period_in_months}` : null;
    window.open(url);
  }

  excel() {
    let url = `${environment.api_raw_base_url}installments/excel/${this.unit_details.id}/${this.new_paymentForm.type}?generated_view=${this.new_paymentForm.generated_view}&slots=${this.new_paymentForm.slots}&service_room_slots=${this.new_paymentForm.service_room_slots}&service_room_with_bathroom_slots=${this.new_paymentForm.service_room_with_bathroom_slots}&finishing_type_id=${this.new_paymentForm.finishing_type_id}&extra_discount=${this.new_paymentForm.extra_discount}`;

    if (this.userProfile.role === "Admin" || this.userProfile.role == "CFO") {
      url += `&tot_amount_for_unit=${this.new_paymentForm.price}`;
    }
    url += `&starting_date=${this.new_paymentForm.starting_date}`;
    this.new_paymentForm.generator_type == 'Mortage Calculator' ? url += `&contract_period_in_months=${this.new_paymentForm.contract_period_in_months}` : null;
    window.open(url);
  }

  reassignInstallmentsDetails() {
    this.installmentsDetails = {
      down_payment_installment_count: null,
      down_payment_installment_value: null,
      down_payment_installment_total_value: null,
      first_down_payment_installment_date: null,
      down_payment_installment_periodly_value: null,
      down_payment_installment_periodly_total_value: null,


      special_payments_arr: [],
      special_payment_installment_count: null,
      special_payment_installment_value: null,
      special_payment_installment_total_value: null,
      first_special_payment_installment_date: null,
      special_payment_periodly_amount: null,
      special_payment_periodly_total_value: null,


      maintenance_installment_count: null,
      maintenance_installment_value: null,
      maintenance_installment_total_value: null,
      first_maintenance_installment_date: null,


      maintenance_fees_count: null,
      maintenance_fees_value: null,
      maintenance_fees_total_value: null,
      first_maintenance_fees_date: null,
      maintenance_fees_periodly_value: null,
      maintenance_fees_periodly_total_value: null,


      garage_fees_count: null,
      garage_fees_value: null,
      garage_fees_total_value: null,
      first_garage_fees_date: null,
      garage_fees_periodly_value: null,
      garage_fees_periodly_total_value: null,


      regular_installment_count: null,
      regular_installment_value: null,
      regular_installment_total_value: null,
      first_regular_installment_date: null,
      regular_periodly_amount: null,
      regular_periodly_total_value: null,

    };
  }

  getInstallments(paymentForm: NgForm) {
    if (paymentForm.invalid) {
      return;
    }

    this.slimLoadingBarService.start(() => {
    });

    let data;
    if (this.new_paymentForm.generator_type === "Fixed Plan") {
      data = {
        unit_id: this.unit_id,
        generator_type: this.new_paymentForm.generator_type,
        down_payment: this.new_paymentForm.percentage,
        slots: this.new_paymentForm.slots,
        service_room_slots: this.new_paymentForm.service_room_slots,
        service_room_with_bathroom_slots:
          this.new_paymentForm.service_room_with_bathroom_slots,
        type: this.new_paymentForm.type,
        unit_serial: this.unit_details.serial,
        generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        has_club_house: this.new_paymentForm.has_club_house ? 1 : 0,
        cash_price: this.new_paymentForm.cash_price,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id || null,
        extra_discount: this.new_paymentForm.extra_discount,
      };
    } else {
      data = {
        generator_type: this.new_paymentForm.generator_type,
        slots: this.new_paymentForm.slots,
        // service_room_slots: this.new_paymentForm.service_room_slots,
        // service_room_with_bathroom_slots:
        //   this.new_paymentForm.service_room_with_bathroom_slots,
        // type: this.new_paymentForm.type,
        unit_serial: this.new_paymentForm.unit_serial,
        // generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        has_club_house: this.new_paymentForm.has_club_house ? 1 : 0,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id || null,
        interval: Number(this.new_paymentForm.interval),
        down_payment_interval: Number(
          this.new_paymentForm.down_payment_interval ||
          this.new_paymentForm.interval
        ),
        garage_fees_date: this.new_paymentForm.garage_fees_date,
        maintenance_fees_date: this.new_paymentForm.maintenance_fees_date,
        down_payment_count: this.new_paymentForm.down_payment_count,
        first_installment_date: this.new_paymentForm.first_installment_date,
        cash_price: this.new_paymentForm.cash_price,
        down_payment_type: this.new_paymentForm.down_payment_type,
        down_payment:
          this.new_paymentForm.down_payment_type === "percentage"
            ? this.new_paymentForm.percentage
            : this.new_paymentForm.amount,
        unit_id: this.unit_id,
        ...(this.new_paymentForm.generator_type === "Mortage Calculator" && { contract_period_in_months: this.new_paymentForm.contract_period_in_months }),
      };
      if (this.new_paymentForm.generator_type === "PV Calculator") {
        const downPaymentsPayload = this.buildDownPaymentsPayload();
        const firstDownPayment = downPaymentsPayload[0] || this.defaultDownPayment;
        data.down_payments_array = downPaymentsPayload;
        data.down_payment_type = firstDownPayment.down_payment_type;
        data.down_payment = firstDownPayment.down_payment;
        data.down_payment_interval = firstDownPayment.down_payment_interval;
        data.down_payment_count = downPaymentsPayload.length;
        data.installments_count = this.new_paymentForm.installments_count;
      } else {
        data.installments_count = this.new_paymentForm.installments_count;
      }
      if (this.special_payments.length > 0) {
        data.special_payments = this.special_payments;
      }
    }
    this.paymentService.getInstallments(data).subscribe(
      (data) => {
        this.resetPlanSummary();
        this.mortage_raw = null;
        this.installment_mortage = null;
        this.installmentsDetails = null;
        console.log(this.installmentsDetails);
        if (this.new_paymentForm.generator_type === "Fixed Plan") {
          this.installments = data.main;
          this.separated = data.finishing;
        } else {
          this.mortage_raw = data;
          this.installment_mortage = data.totalPlanArr;
          this.installmentsDetails =
            (data && (data.installmentsDetails || data.installments_details)) ||
            data ||
            {};
          data.totalPlanArr.forEach((item) => {
            if (item.is_down_payment) {
              this.down_payment_arr.push(item);
            } else if (item.is_special_payment) {
              this.special_payment_arr.push(item);
            } else if (
              item.is_extra_payment &&
              item.num === "Maintenance Fees"
            ) {
              this.maintenance_fees_arr.push(item);
            } else if (item.is_extra_payment && item.num === "Garage Fees") {
              this.garage_fees_arr.push(item);
            } else {
              this.regular_payment_arr.push(item);
            }
          });

          if (this.down_payment_arr.length > 0) {
            this.installmentsDetails.down_payment_installment_count =
              this.down_payment_arr.length;
            this.installmentsDetails.down_payment_installment_value =
              this.down_payment_arr[0].installment_value;
            this.installmentsDetails.down_payment_installment_total_value =
              this.down_payment_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
            this.installmentsDetails.down_payment_installment_periodly_value =
              this.down_payment_arr[0].periodly_amount;
            this.installmentsDetails.down_payment_installment_periodly_total_value =
              this.down_payment_arr.reduce(
                (a, b) => a + b.periodly_amount,
                0
              );
            this.installmentsDetails.first_down_payment_installment_date =
              this.down_payment_arr[0].installment_date;
          }
          if (this.special_payment_arr.length > 0) {
            if (this.special_payments.length > 1) {
              let startIndex = 0;
              this.installmentsDetails.special_payments_arr =
                this.special_payments
                  .map((payment, index) => {
                    const count = Number(payment.special_payment_count) || 0;
                    const isLastPayment =
                      index === this.special_payments.length - 1;
                    const installments = this.special_payment_arr.slice(
                      startIndex,
                      isLastPayment ? undefined : startIndex + count
                    );
                    startIndex += count;

                    if (!installments.length) {
                      return null;
                    }

                    return {
                      ...payment,
                      installments,
                      ...this.getSpecialPaymentSummary(installments),
                    };
                  })
                  .filter(Boolean);
            } else {
              Object.assign(
                this.installmentsDetails,
                this.getSpecialPaymentSummary(this.special_payment_arr)
              );
            }
          }
          if (this.regular_payment_arr.length > 0) {
            this.installmentsDetails.regular_installment_count =
              this.regular_payment_arr.length;
            this.installmentsDetails.regular_installment_value =
              this.regular_payment_arr[0].installment_value;
            this.installmentsDetails.regular_installment_total_value =
              this.regular_payment_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
            this.installmentsDetails.regular_periodly_amount =
              this.regular_payment_arr[0].periodly_amount;
            this.installmentsDetails.regular_periodly_total_value =
              this.regular_payment_arr.reduce(
                (a, b) => a + b.periodly_amount,
                0
              );
            this.installmentsDetails.first_regular_installment_date =
              this.regular_payment_arr[0].installment_date;
          }
          if (this.maintenance_fees_arr.length > 0) {
            this.installmentsDetails.maintenance_fees_count =
              this.maintenance_fees_arr.length;
            this.installmentsDetails.first_maintenance_fees_date =
              this.maintenance_fees_arr[0].installment_date;
            this.installmentsDetails.maintenance_fees_value =
              this.maintenance_fees_arr[0].installment_value;
            this.installmentsDetails.maintenance_fees_total_value =
              this.maintenance_fees_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
            this.installmentsDetails.maintenance_fees_periodly_value =
              this.maintenance_fees_arr[0].periodly_amount;
            this.installmentsDetails.maintenance_fees_periodly_total_value =
              this.maintenance_fees_arr.reduce(
                (a, b) => a + b.periodly_amount,
                0
              );
          }
          if (this.garage_fees_arr.length > 0) {
            this.installmentsDetails.garage_fees_count =
              this.garage_fees_arr.length;
            this.installmentsDetails.first_garage_fees_date =
              this.garage_fees_arr[0].installment_date;
            this.installmentsDetails.garage_fees_value =
              this.garage_fees_arr[0].installment_value;
            this.installmentsDetails.garage_fees_total_value =
              this.garage_fees_arr.reduce((a, b) => a + b.installment_value, 0);
            this.installmentsDetails.garage_fees_periodly_value =
              this.garage_fees_arr[0].periodly_amount;
            this.installmentsDetails.garage_fees_periodly_total_value =
              this.garage_fees_arr.reduce((a, b) => a + b.periodly_amount, 0);
          }
        }
        this.slimLoadingBarService.complete();
        this.canReserveUnit = true;
        // this.datatableHandle();
        // this.show =true;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  resetPlanSummary() {
    this.garage_fees_arr = [];
    this.down_payment_arr = [];
    this.special_payment_arr = [];
    this.special_payment_arr = [];
    this.regular_payment_arr = [];
    this.maintenance_fees_arr = [];
  }

  private getSpecialPaymentSummary(installments: any[]) {
    return {
      special_payment_installment_count: installments.length,
      special_payment_installment_value: this.toNumber(
        installments[0].installment_value
      ),
      special_payment_installment_total_value: installments.reduce(
        (a, b) => a + this.toNumber(b.installment_value),
        0
      ),
      special_payment_periodly_amount: this.toNumber(
        installments[0].periodly_amount
      ),
      special_payment_periodly_total_value: installments.reduce(
        (a, b) => a + this.toNumber(b.periodly_amount),
        0
      ),
      first_special_payment_installment_date: installments[0].installment_date,
    };
  }

  private toNumber(value: any): number {
    const normalizedValue =
      value === null || value === undefined ? 0 : value;
    return Number(String(normalizedValue).replace(/,/g, "")) || 0;
  }

  exportWithMortageCalculator(fileType: string) {
    this.slimLoadingBarService.start(() => {
    });
    let data;
    if (this.new_paymentForm.generator_type === "Fixed Plan") {
      data = {
        generator_type: this.new_paymentForm.generator_type,
        down_payment: this.new_paymentForm.percentage,
        slots: this.new_paymentForm.slots,
        service_room_slots: this.new_paymentForm.service_room_slots,
        service_room_with_bathroom_slots:
          this.new_paymentForm.service_room_with_bathroom_slots,
        type: this.new_paymentForm.type,
        unit_serial: this.unit_details.serial,
        generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        has_club_house: this.new_paymentForm.has_club_house ? 1 : 0,
        cash_price: this.new_paymentForm.cash_price,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id || null,
        unit_id: this.unit_id,
        contract_period_in_months: this.new_paymentForm.contract_period_in_months,
        extra_discount: this.new_paymentForm.extra_discount,
      };
    } else {
      const contractPeriod = this.new_paymentForm.installments_count;
      data = {
        generator_type: this.new_paymentForm.generator_type,
        slots: this.new_paymentForm.slots,
        service_room_slots: this.new_paymentForm.service_room_slots,
        service_room_with_bathroom_slots:
          this.new_paymentForm.service_room_with_bathroom_slots,
        type: this.new_paymentForm.type,
        unit_serial: this.new_paymentForm.unit_serial,
        generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        has_club_house: this.new_paymentForm.has_club_house ? 1 : 0,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id || null,
        interval: Number(this.new_paymentForm.interval),
        down_payment_interval: Number(
          this.new_paymentForm.down_payment_interval ||
          this.new_paymentForm.interval
        ),
        down_payment_count: this.new_paymentForm.down_payment_count,
        first_installment_date: this.new_paymentForm.first_installment_date,
        cash_price: this.new_paymentForm.cash_price,
        down_payment_type: this.new_paymentForm.down_payment_type,
        down_payment:
          this.new_paymentForm.down_payment_type === "percentage"
            ? this.new_paymentForm.percentage
            : this.new_paymentForm.amount,
        unit_id: this.unit_id,
      };
      if (this.new_paymentForm.generator_type === "PV Calculator") {
        const downPaymentsPayload = this.buildDownPaymentsPayload();
        const firstDownPayment = downPaymentsPayload[0] || this.defaultDownPayment;
        data.down_payments_array = downPaymentsPayload;
        data.down_payment_type = firstDownPayment.down_payment_type;
        data.down_payment = firstDownPayment.down_payment;
        data.down_payment_interval = firstDownPayment.down_payment_interval;
        data.down_payment_count = downPaymentsPayload.length;
        data.installments_count = contractPeriod;
      } else {
        data.contract_period_in_months = this.new_paymentForm.contract_period_in_months;
      }
      if (this.special_payments.length > 0) {
        data.special_payments = this.special_payments;
      }
    }
    data.export_file = fileType;
    this.paymentService.getInstallments(data).subscribe(
      (data) => {
        window.open(data.url, "_blank");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getUnitDetails(unit_id) {
    this.projectService.getUnitDetails(unit_id).subscribe(
      (data) => {
        this.unit_details = data;
        this.fillTheForm(data);
        this.unit_details.finishing_types.map((type) => {
          if (type.name == "Core and Shell") {
            this.new_paymentForm.finishing_type_id = type.id;
            this.onFinishTypePriceChange(type.id);
          }
        })
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  checkUnitIdQueryParameter() {
    this.route.queryParams.pipe(
      filter((params) => params.unit_id))
      .subscribe((params) => {
        this.unit_id = params.unit_id;
        this.new_paymentForm.unit_id = params.unit_id;
        this.getUnitDetails(params.unit_id);
      });
  }

  fillTheForm(unit_details) {
    this.new_paymentForm.unit_serial = unit_details.serial;
    this.new_paymentForm.project_type = unit_details.project.type;
    this.new_paymentForm.status = unit_details.status;
    this.new_paymentForm.extra_discount = unit_details.extra_discount;
    this.new_paymentForm.type = "";
    this.phases = unit_details.project.phases;
    this.unit_details = unit_details;
    // this.getPaymentTerms(unit_details.project.id);
    this.new_paymentForm.percentage = "";
    this.new_paymentForm.phase_id = unit_details.phase_id;
    this.new_paymentForm.build_area = unit_details.build_area;
    this.new_paymentForm.maintenance_fees_date = null;
    this.new_paymentForm.garage_fees_date = null;
    this.new_paymentForm.contract_period_in_months = unit_details.contract_period_in_months;
  }

  onGeneratorTypeChange(event) {
    this.new_paymentForm.finishing_type_id &&
      this.onFinishTypePriceChange(this.new_paymentForm.finishing_type_id);
    if (this.new_paymentForm.generator_type == "PV Calculator") {
      this.syncDownPaymentsArray();
    } else if (this.new_paymentForm.generator_type == "Mortage Calculator") {
      this.onIntervalChange(3);
    } else {
      this.down_payments_array = [];
    }
  }

  setSpecialPaymentDate(interval) {
    this.special_payment.special_payment_date = format(addMonths(new Date(this.new_paymentForm.starting_date), interval), 'yyyy-MM-dd');
  }

  onIntervalChange = (event) => {
    this.calculateFirstInstallmentDate();
  };

  onDownPaymentIntervalChange = () => {
    this.calculateFirstInstallmentDate();
  };

  onDownPaymentCountChange = () => {
    this.syncDownPaymentsArray();
    this.calculateFirstInstallmentDate();
  };

  onStartingDateChange = () => {
    this.calculateFirstInstallmentDate();
  };

  calculateFirstInstallmentDate() {
    const baseDateInput = this.new_paymentForm.starting_date;
    const baseDate = baseDateInput
      ? startOfDay(parseISO(baseDateInput))
      : startOfDay(new Date());

    if (!isValid(baseDate)) {
      return;
    }

    const fallbackIntervalMonths = this.resolveIntervalMonths(
      this.new_paymentForm.down_payment_interval,
      this.resolveIntervalMonths(
        this.new_paymentForm.interval,
        Number(this.defaultDownPaymentInterval)
      )
    );

    if (!Number.isFinite(fallbackIntervalMonths) || fallbackIntervalMonths < 0) {
      return;
    }

    const installmentIntervalMonths = this.resolveIntervalMonths(
      this.new_paymentForm.interval,
      fallbackIntervalMonths
    );

    const totalDownPaymentDurationMonths = this.getTotalDownPaymentDuration(
      fallbackIntervalMonths
    );

    const firstInstallmentDate = addDays(
      addMonths(
        baseDate,
        totalDownPaymentDurationMonths + installmentIntervalMonths
      ),
      this.firstInstallmentDayIncrement
    );

    this.new_paymentForm.first_installment_date = format(firstInstallmentDate, "yyyy-MM-dd");
  }

  private getTotalDownPaymentDuration(fallbackIntervalMonths: number): number {
    if (
      this.new_paymentForm.generator_type === "PV Calculator" &&
      this.down_payments_array.length
    ) {
      return this.down_payments_array.reduce((total, payment) => {
        const intervalMonths = this.resolveIntervalMonths(
          payment.down_payment_interval,
          fallbackIntervalMonths
        );
        return total + intervalMonths;
      }, 0);
    }

    const downPaymentCount = Number(this.new_paymentForm.down_payment_count) || 0;
    if (downPaymentCount <= 0) {
      return 0;
    }

    const downPaymentIntervalMonths = this.resolveIntervalMonths(
      this.new_paymentForm.down_payment_interval,
      fallbackIntervalMonths
    );

    return downPaymentIntervalMonths * downPaymentCount;
  }

  private resolveIntervalMonths(rawInterval: any, fallback: number): number {
    const parsedInterval = Number(rawInterval);
    if (Number.isFinite(parsedInterval) && parsedInterval >= 0) {
      return parsedInterval;
    }
    if (Number.isFinite(fallback) && fallback >= 0) {
      return fallback;
    }
    return 0;
  }

  private syncDownPaymentsArray() {
    const count = Number(this.new_paymentForm.down_payment_count) || 0;
    if (count <= 0 || this.new_paymentForm.generator_type !== "PV Calculator") {
      this.down_payments_array = [];
      return;
    }
    const existing: DownPaymentEntry[] = [...this.down_payments_array];
    this.down_payments_array = Array.from({ length: count }, (_, idx) => {
      const current: DownPaymentEntry = existing[idx] || this.defaultDownPayment;
      return {
        down_payment_type: current.down_payment_type || "percentage",
        down_payment: current.down_payment || null,
        down_payment_interval: this.defaultDownPaymentInterval,
      };
    });
  }

  private buildDownPaymentsPayload() {
    return (this.down_payments_array || []).map((payment) => ({
      down_payment_type: payment.down_payment_type || null,
      down_payment:
        payment.down_payment !== null && payment.down_payment !== undefined
          ? Number(payment.down_payment)
          : null,
      down_payment_interval:
        payment.down_payment_interval !== null &&
          payment.down_payment_interval !== undefined
          ? Number(payment.down_payment_interval)
          : null,
    }));
  }

  showValidationErrors(paymentForm: NgForm) {
    const missingFields: string[] = [];

    // Check each form control for validation errors
    Object.keys(paymentForm.controls).forEach(controlName => {
      const control = paymentForm.controls[controlName];

      if (control.invalid && control.errors) {
        let fieldName = this.getFieldDisplayName(controlName);

        // Check specific validation errors
        if (control.errors['required']) {
          missingFields.push(`${fieldName} is required`);
        } else if (control.errors['minlength']) {
          missingFields.push(`${fieldName} must be at least ${control.errors['minlength'].requiredLength} characters`);
        } else if (control.errors['maxlength']) {
          missingFields.push(`${fieldName} must not exceed ${control.errors['maxlength'].requiredLength} characters`);
        } else if (control.errors['pattern']) {
          missingFields.push(`${fieldName} format is invalid`);
        } else if (control.errors['email']) {
          missingFields.push(`${fieldName} must be a valid email address`);
        } else {
          missingFields.push(`${fieldName} is invalid`);
        }
      }
    });

    if (missingFields.length > 0) {
      const errorMessage = `Please fix the following validation errors:\n\n${missingFields.join('\n')}`;

      swal('Validation Errors', errorMessage, 'error');
    }
  }

  getFieldDisplayName(controlName: string): string {
    const fieldNames: { [key: string]: string } = {
      'generator_type': 'Generate Type',
      'unit_serial': 'Unit Serial',
      'unit_id': 'Unit ID',
      'finishing_type_id': 'Finish Type',
      'type': 'Payment Method Type',
      'generated_view': 'Generated View',
      'price': 'Unit List Price',
      'cash_price': 'Unit Cash Price',
      'status': 'Unit Status',
      'build_area': 'Unit Area',
      'contract_period_in_months': 'Contract Period In Months',
      'installments_count': 'Installments Count',
      'percentage': 'Down Payment %',
      'down_payment_type': 'Down Payment Type',
      'amount': 'Down Payment Amount',
      'slots': 'Number of parking Slots',
      'service_room_slots': 'Number of Service Room Slots',
      'service_room_with_bathroom_slots': 'Number of Service Room With Bathroom Slots',
      'starting_date': 'Starting Date',
      'first_installment_date': 'First Installment Date',
      'down_payment_count': 'Down Payment Count',
      'down_payment_interval': 'Down Payment Interval',
      'interval': 'Interval',
    };

    return fieldNames[controlName] || controlName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  addSpecialPayment() {
    this.special_payments.push({ ...this.special_payment });
    this.special_payment = {
      special_payment_type: "percentage",
      special_payment_value: null,
      special_payment_count: null,
      special_payment_interval: "12",
      special_payment_date: null,
    };
  }

  deleteSpecialPayment(index) {
    this.special_payments.splice(index, 1);
  }

  reserve() {
    const special_payment_list = JSON.stringify(this.special_payments);
    const is_special_payment = this.special_payments.length > 0 ? true : false;
    const reserveData = {
      generator_type: this.new_paymentForm.generator_type,
      installments_count: this.new_paymentForm.installments_count,
      down_payment_type: this.new_paymentForm.down_payment_type,
      contract_period_in_months: this.new_paymentForm.contract_period_in_months,
      percentage: this.new_paymentForm.percentage,
      amount: this.new_paymentForm.amount,
      down_payment_interval: this.new_paymentForm.down_payment_interval,
      interval: this.new_paymentForm.interval,
      starting_date: this.new_paymentForm.starting_date,
      down_payment_count: this.new_paymentForm.down_payment_count,
      first_installment_date: this.new_paymentForm.first_installment_date,
      status: this.new_paymentForm.status,
      build_area: this.new_paymentForm.build_area,
      maintenance_fees_date: this.new_paymentForm.maintenance_fees_date,
      garage_fees_date: this.new_paymentForm.garage_fees_date,
      special_payments: special_payment_list,
      cash_price: this.new_paymentForm.cash_price,
      down_payments_array: JSON.stringify(this.down_payments_array),
    };

    sessionStorage.setItem('reserveData', JSON.stringify(reserveData));

    this.router.navigate([`pages/reservations/add/`, this.unit_id], {
      queryParams: {
        has_reserve_data: true
      },
    });
  }

  printPdf() {
    this.generating_pdf = true;
    this.slimLoadingBarService.start();
    this.paymentService.getOfferPdf(this.new_paymentForm).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.generating_pdf = false;
        window.open(`https://${res.url}`);
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
        this.generating_pdf = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-generator/payment-generator.component.ts